import { useRoutes } from 'react-router-dom';
import AppRoutes from './appRoutes';

export default function ThemeRoutes() {
  // return useRoutes([LoginRoutes, ComponentsRoutes, MainRoutes, AppRoutes]);
  return useRoutes([AppRoutes]);
}
